const NON_PRODUCTION_HOSTS = [
  'localhost',
  '127.0.0.1',
  'development.atellio.com',
  'app.qa.atellio.com'
];

/** Local, development and QA apps: where test data and unfinished features are fine. */
export function isNonProductionHost(hostname: string): boolean {
  return NON_PRODUCTION_HOSTS.includes(hostname);
}
